<template>
  <div>

    <Spinner v-if="loading === true" />

    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button">
        <button
          id="deleteMultiple"
          type="button"
          class="btn btn-outline-primary mb-2"
          @click="confirmDeleteText(deletedArry)"
        >
          Delete Selected Elements
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2 ml-1"
          data-toggle="modal"
          data-target="#createModal"
        >
          Create
        </button>
        <create
          v-if="$router.currentRoute.name === 'project-contracts'"
          @refresh="getContract()"
        />
      </div>
    </div>
    <basic-table
      v-if="loading === false"
      ref="table"
      :columns="columns"
      :values="rows"
      :actions-obj="actionsArray"
      @dynamicAction="handleActions($event)"
      @choosenObject="getEditedObject($event)"
      @deleteItems="removeItems($event)"
      @deletedMultipleIds="catchIds($event)"
      @changeStatus="updateStatus($event)"
    />
    <edit
      v-if="$router.currentRoute.name === 'project-contracts'"
      :contract="editedContract"
      @refresh="getContract()"
    />
    <changeOwnership
      :contract="contractId"
      @refresh="getContract()"
    />
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import BasicTable from '../../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import ChangeOwnership from './changeOwnership.vue'
import projectService from '../../../../services/projectService'
import Spinner from '@/shared/loader/Spinner.vue'

export default {
  components: {
    Spinner,
    BRow,
    BCol,
    Create,
    Edit,
    ChangeOwnership,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      actionsArray: [],
      editedContract: '',
      contractId: '',
      columns: [
        {
          label: 'Reference Number',
          field: 'referenceNumber',
        },
        {
          label: 'Project',
          field: 'projectName',
        },
        {
          label: 'Client',
          field: 'user.fullName',
        },
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Date',
          field: 'signingDate',
        },
        {
          label: 'File',
          field: 'file.url',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getContract()
    this.actionsArray = [{ title: 'Invoices', icon: 'DollarSignIcon' }]
  },
  methods: {
    getContract() {
      this.loading = true
      projectService.contract(this.$route.params.id).then(response => {
        this.rows = response.data.data
        this.loading = false
      })
    },
    handleActions(itemObj) {
      console.log(itemObj)
      switch (itemObj.key) {
        case 'Representatives':
          this.$router.push({ name: 'representatives', params: { id: itemObj.id } })
          break
        case 'Invoices':
          this.$router.push({ name: 'contract-invoices', params: { id: itemObj.id } })
          break
        case 'Change Ownership':
          this.contractId = itemObj
          $('#changeOwnershipModal').modal('show')
          break
        default:
          console.log('Action Object *******>', itemObj)
      }
      // this.$router.push({ name: 'representatives', params: { id: itemId } })
    },
    getEditedObject(obj) {
      this.editedContract = obj
    },
    catchIds(ids) {
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            clientService.delete(arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })
              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    updateStatus(row){
      console.log(row)
      this.confirmChangeStatusText(row)
    },
    confirmChangeStatusText(row) {
      this.loading = true

      if (row.id !== null && row.id !== undefined ) {
        this.$swal({
          title: 'Are you sure of changing status?',
          text: "",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, change it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            projectService.changeContractStatus(this.$route.params.id, row.id).then(response => {

              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Changed!',
                  text: 'Status has been changed.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                  this.loading = false

                })
              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    renderTable() {
      this.getContract()
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
.vgt-responsive {
  width: 100%;
  overflow-x: unset!important;
  position: relative;
}
</style>
